import { cn } from '../../lib/cn';
import type { PerformanceSecurityUXRow } from '../../architecturegovernance/framework';

type Props = { items?: PerformanceSecurityUXRow[] };

export function PerformanceSecurityUXPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <div key={`${item.domain}-${item.metric}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{item.domain}</p>
          <p className="text-sm font-medium">{item.metric}</p>
          <p className="text-xs text-slate-500">Target: {item.target}</p>
          <span className={cn(
            'mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium',
            item.status === 'compliant' || item.status === 'within_budget'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
